module.exports = __webpack_public_path__ + "media/images/campo-de-futebol2-178b000485013c89aa0fbf3d87629d37.png";